import React from 'react';
import HideUnrelatedEvents from './HideUnrelatedEvents';
import styles from '../build-structure.module.scss';
import { EventSetNavigationControls } from '../../../controls/EventSetNavigationControls';
import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import {
  resetCapitalStructureExpandedEvents,
  resetExpandStructureInstruments,
} from '@app/core/store/ui-values-slice';

const BuildStructureControls: React.FC = () => {
  const dispatch = useAppDispatch();
  const hideUnrelatedEventsToggleDisplay = useAppSelector(
    (state) => state.uiValues.hideUnrelatedEventsToggleDisplay
  );
  return (
    <div className={styles['controls']}>
      <EventSetNavigationControls
        resetFunction={() => {
          dispatch(resetCapitalStructureExpandedEvents());
          dispatch(resetExpandStructureInstruments());
        }}
      />
      {hideUnrelatedEventsToggleDisplay && <HideUnrelatedEvents />}
    </div>
  );
};

export default BuildStructureControls;
